import { styled } from "styled-components";
import { useSearchspringPLPContext } from "../../contexts/SearchspringPLPContext";
import { buttonReset, colors, font } from "../../lib/sharedStyles";
import { X } from "@fenderdigital/ui/Icons";
import { SearchResponseModelFilterValue } from "@searchspring/snapi-types";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 16px;

  @media (max-width: 1023px) {
    flex-wrap: wrap;
    padding-left: 0;
  }
`;

const Filter = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 16px;
  border-radius: 24px;
  background: ${colors.fender.grey01};
  ${font('Instrument Sans', 400, '12px', '18px')};
  letter-spacing: 0.12px;
  color: ${colors.fender.primaryDark};

  svg {
    margin-left: 8px;
  }
`;

const ClearButton = styled.button`
  ${buttonReset()};
  ${font('Instrument Sans', 400, '12px', '20px')};
  line-height: 20px;
  color: ${colors.fender.primaryDark};
  text-decoration: underline;
  margin-left: 8px;

  @media (max-width: 1023px) {
    width: 100%;
    text-align: left;
  }
`;

const PLPActiveFilters = () => {
  const { activeFilters, clearPLPFilters, filterPLP } = useSearchspringPLPContext();

  const handleClick = (filter: SearchResponseModelFilterValue) => {
    const { field, value, type } = filter;

    if (field && value) {
      filterPLP(field, filter, type);
    }
  }

  return (
    <Container>
      {activeFilters.map(filter => (
        <Filter key={`${filter.field}-${filter.value}-${filter.label}`} onClick={() => handleClick(filter)}>
          {filter.label}
          <X fill={colors.fender.primaryDark} fontSize="10px" />
        </Filter>
      ))}
      {(activeFilters.length > 1) && (
        <ClearButton onClick={() => clearPLPFilters()}>Clear All</ClearButton>
      )}
    </Container>
  );
}

export default PLPActiveFilters;